import React from "react";
import filter from "../filter-icon.png";
import { FaFilter } from "react-icons/fa";

const AppliedFilters = ({ appliedFilters, removeFilter, editFilters }) => {

    const getFilterLabel = (key) => {
        const labels = {
            industry: "Industry",
            sector: "Sector",
            tag: "Tag",
            city: "City",
            dealAmount: "Deal Amount",
            latestRound: "Latest Round",
            investors: "Investors",
            revenueGrowth: "Revenue Growth",
            ebitdaGrowth: "EBITDA Growth",
            patGrowth: "PAT Growth",
            operatingMargin: "Operating Margin",
            contributionMargin: "Contribution Margin",
            revenue: "Revenue",
            ebitda: "EBITDA",
            pat: "PAT",
            fin_type: null
        };
        return labels[key] || key;
    };

    const formatFilterValue = (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (value.operator && value.value !== undefined) {
                const opSymbols = { gte: '>', eq: '=', lte: '<' };
                return `${opSymbols[value.operator] || value.operator} ${value.value}%`;
            }
        }
        return value;
    };
    
    
  return (
    <>
      {Object.keys(appliedFilters).length > 0 && (
        <FaFilter color="#bc8b20" size={18} 
          className="mx-2 cursor-pointer"
          title="Edit Filters"
          onClick={editFilters}
        />
      )}
      {/* Applied Filters View */}
      {Object.keys(appliedFilters).length > 0 &&
        Object.entries(appliedFilters).map(([key, value]) => {
          // Skip page and fin_type from display
          if (key === "page" || key === "fin_type" || key === "tag_operator" || key === "investors_operator") return null;
          const formattedValue = formatFilterValue(key, value);
          if (!formattedValue) return null;
          return (
            <div
              key={key}
              className="flex items-center gap-1 bg-slate-600/10 text-slate-600 px-2 py-1 rounded text-xs font-medium"
            >
              <span>
                {Array.isArray(value) ? getFilterLabel(key)  : `${getFilterLabel(key)} : ${formattedValue}`}
              </span>
              <button
                onClick={() => removeFilter(key)}
                className="ml-1 hover:text-red-500 font-bold"
                title="Remove filter"
              >
                ×
              </button>
            </div>
          );
        })}
    </>
  );
};

export default AppliedFilters;
